export default class DayBookingOption {
    constructor(json) {
        this.date = json.date;
        this.timeslots = json.timeslots;
        this.bookedCapacity = json.bookedCapacity;
        this.cateringServiceText = json.cateringServiceText;
    }
}
